module.exports = __webpack_public_path__ + "img/press-05.eb5911e8.jpeg";